import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/slices/authSlice";
import { useHistory } from "react-router-dom";

import "./SideNav.scss";
import { RxHamburgerMenu } from "react-icons/rx";
import { MdOutlineCancel } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { BsCalendarDate } from "react-icons/bs";
import { RxDashboard } from "react-icons/rx";
import { HiOutlineUserGroup } from "react-icons/hi";
import { FaUserClock } from "react-icons/fa6";
import { FaHouseChimneyUser } from "react-icons/fa6";
import { TbReport } from "react-icons/tb";
import { RiLogoutBoxLine } from "react-icons/ri";
import { BiCategoryAlt } from "react-icons/bi";
import { MdOutlineHolidayVillage } from "react-icons/md";
import { FaPeopleRoof } from "react-icons/fa6";
import { TbBuildingEstate } from "react-icons/tb";
import { MdAttachEmail } from "react-icons/md";


const SideNav = () => {
  console.log("baseURL: " + process.env.REACT_APP_API_URL);
  const dispatch = useDispatch();
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);

  const toggleNav = () => {
    setIsOpen(!isOpen);
  };

  const closeNav = () => {
    setIsOpen(false);
  };

  const handleDashboard = () => {
    closeNav();
    history.push("/");
  };

  const handleBlockManage = () => {
    closeNav();
    history.push("/blockmanagement");
  };

  const handleHousestatus = () => {
    closeNav();
    history.push("/housestatus");
  };

  const handleHousedetails = () => {
    closeNav();
    history.push("/housedetails");
  };

  const handleVillage = () => {
    closeNav();
    history.push("/villages");
  };

  const HandlePanchayat = () => {
    closeNav();
    history.push("/panchayat");
  };

  const HandleCategory = () => {
    closeNav();
    history.push("/category");
  };

  const handleYear = () => {
    closeNav();
    history.push("/year");
  };

  const handleReport = () => {
    closeNav();
    history.push("/report");
  };

  const handleSupervisor = () => {
    closeNav();
    history.push("/supervisor");
  };
  const handleSchemes = () => {
    closeNav();
    history.push("/schemes");
  };
  const handleDistricts = () => {
    closeNav();
    history.push("/districts");
  };
  const handleBlockEmails = () => {
    closeNav();
    history.push("/blockEmails");
  };

  const handleLogout = () => {
    dispatch(logout());
    history.push("/");
  };
  const location = useLocation();
  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };
  return (
    <div className={`side-nav-container ${isOpen ? "active" : ""}`}>
      <button className="toggle-button" onClick={toggleNav}>
        {isOpen ? <MdOutlineCancel /> : <RxHamburgerMenu />}
      </button>

      <div className="side-nav-logo">
        <img src="images/favicon.png" alt="" />
      </div>
      <div className="side-nav-content">
        <div className="side-nav-links">
          <div className={`side-nav-details ${isActive("/")}`} onClick={handleDashboard}>
            <RxDashboard />
            <p>Dashboard</p>
          </div>

          <div className={`side-nav-details ${isActive("/blockmanagement")}`} onClick={handleBlockManage}>
            <HiOutlineUserGroup />
            <p>Block Management</p>
          </div>

          <div className={`side-nav-details ${isActive("/year")}`} onClick={handleYear}>
            <BsCalendarDate />
            <p>Year</p>
          </div>
          <div className={`side-nav-details ${isActive("/panchayat")}`} onClick={HandlePanchayat}>
            <FaPeopleRoof />
            <p>Panchayat </p>
          </div>
          <div className={`side-nav-details ${isActive("/villages")}`} onClick={handleVillage}>
            <MdOutlineHolidayVillage />
            <p>Village </p>
          </div>
          <div className={`side-nav-details ${isActive("/districts")}`} onClick={handleDistricts}>
            <TbBuildingEstate />
            <p>Districts </p>
          </div>
          <div className={`side-nav-details ${isActive("/blockEmails")}`} onClick={handleBlockEmails}>
            <MdAttachEmail/>
            <p>BlockEmails </p>
          </div>
          <div className={`side-nav-details ${isActive("/category")}`} onClick={HandleCategory}>
            <BiCategoryAlt />
            <p>Category</p>
          </div>
          <div className={`side-nav-details ${isActive("/housestatus")}`} onClick={handleHousestatus}>
            <FaHouseChimneyUser />
            <p>House Status</p>
          </div>
          <div className={`side-nav-details ${isActive("/schemes")}`} onClick={handleSchemes}>
            <FaHouseChimneyUser />
            <p>Schemes</p>
          </div>
          <div className={`side-nav-details ${isActive("/supervisor")}`} onClick={handleSupervisor}>
            <FaUserClock />
            <p>Supervisor Details</p>
          </div>
          <div className={`side-nav-details ${isActive("/housedetails")}`} onClick={handleHousedetails}>
            <FaHouseChimneyUser />
            <p>House Details</p>
          </div>
          <div className={`side-nav-details ${isActive("/report")}`} onClick={handleReport}>
            <TbReport />
            <p>House Report</p>
          </div>
        </div>
        <div className="logout-button">
          <button onClick={handleLogout}>
            <RiLogoutBoxLine />
            <p>Logout</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SideNav;
